export enum StatsSaleItemType {
  Dashboard = 'dashboard',
  List = 'list',
  Booking = 'booking',
}
